<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="epig"> </p>
<p class="EP">Wherever you go, there are plenty of places where you will find a welcome; and if you choose to go to Thessaly, I have friends there who will make much of you and give you complete protection, so that no one in Thessaly can interfere with you.</p>
<p class="EPC"><span class="ePub-SC">—</span>P<span class="ePub-SC">LATO</span>,<span class="ePub-I"> Crito</span></p>
<p class="EP">The triremes which defended Greece at Salamis defended Mars too.</p>
<p class="EPC"><span class="ePub-SC">—</span>A<span class="ePub-SC">DA </span>P<span class="ePub-SC">ALMER, </span><span class="ePub-I">Dogs of Peace</span></p>
<p class="EP">Yes, I know, Plato; but if you always take the steps in threes, one day you will miss a cracked one.</p>
<p class="EPC"><span class="ePub-SC">—</span>M<span class="ePub-SC">ARY </span>R<span class="ePub-SC">ENAULT, </span><span class="ePub-I">The Last of the Wine</span></p>
<p class="EP-V">If you could take that first step</p>
<p class="EP-V">You could dance with Artemis</p>
<p class="EP-V-S">Beside Apollo Eleven.</p>
<p class="EPC"><span class="ePub-SC">—</span>J<span class="ePub-SC">O </span>W<span class="ePub-SC">ALTON,</span><span class="epc-r"> “Submersible Moonphase”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?f9617006